import { useState } from "react";
import { SectionMark } from "@/components/section-mark";
import { Button } from "@/components/ui/button";
import { TestimonialsTape } from "@/components/testimonials-tape";
import bartekPhoto from "@/assets/bartek-lalek.jpg.asset.json";
import iwonaPhoto from "@/assets/iwona-borawska.jpg.asset.json";
import jakubPhoto from "@/assets/jakub-kocjan.jpg.asset.json";
import kamilaPhoto from "@/assets/rekomendacja-mastermind.jpg.asset.json";
import januszPhoto from "@/assets/janusz-zielinski.png.asset.json";

type Testimonial = {
  name: string;
  /** Podpis autorki lub autora; gdy brak, karta pokazuje samo imię i nazwisko. */
  role?: string;
  photo?: string;
  intro: string;
  rest: string[];
};

const testimonials: Testimonial[] = [
  {
    name: "Bartek Lalek",
    role: "przedsiębiorca, Founder Silent Sound",
    photo: bartekPhoto.url,
    intro:
      "Mastermind organizowany przez Sylwię jest dla mnie czymś znacznie więcej niż kolejnym spotkaniem biznesowym. To wyjątkowa przestrzeń, w której mogę szczerze rozmawiać nie tylko o sukcesach, ale również o trudnościach, wątpliwościach i problemach, z którymi na co dzień często zostaję sam.",
    rest: [
      "Ogromną wartość daje mi starannie dobrane grono doświadczonych przedsiębiorców, ich różne perspektywy oraz szczere informacje zwrotne. Dzięki jasno określonym zasadom dyskrecji i wzajemnemu zaufaniu mogę naprawdę się otworzyć i mówić o tym, co jest dla mnie ważne.",
      "Te spotkania pomogły mi uporządkować wiele kwestii, spojrzeć z dystansem na swoje decyzje i znaleźć rozwiązania, których sam wcześniej nie dostrzegałem. Sylwia stworzyła bezpieczną i bardzo wartościową przestrzeń, za co jestem jej naprawdę wdzięczny.",
      "Z pełnym przekonaniem polecam taki mastermind każdemu przedsiębiorcy. Dla mnie udział w nim jest jednym z najbardziej wartościowych doświadczeń rozwojowych ostatniego czasu.",
    ],
  },
  {
    name: "Iwona Borawska",
    role: "Founderka & CEO The Process®",
    photo: iwonaPhoto.url,
    intro:
      "Sylwia zrobiła coś niezwykłego. Połączyła osoby z przeróżnymi doświadczeniami, zupełnie innymi perspektywami i na różnych etapach życia - i zbudowała nie tylko grupę mastermindową. Zbudowała małą społeczność ludzi, którzy chcą dzielić się swoimi zasobami, wspierać się i inspirować.",
    rest: [
      "Ogrom empatii, ciepło i zaangażowanie Sylwii to coś, co buduje jakość naszych spotkań. A jasne zasady dają poczucie bezpieczeństwa.",
      "Sylwia jest psycholożką i przedsiębiorczynią - te dwie perspektywy sprawiają, że te spotkania mają dla mnie tak ogromną wartość. Są merytoryczne, praktyczne, a jednak osadzone na emocjach i psychologicznych podstawach.",
    ],
  },
  {
    name: "Jakub Kocjan",
    role: "przedsiębiorca. Prowadzi KoKo Kamper, rozwija sprzedaż w HalMod, doradza przy Predictive Index.",
    photo: jakubPhoto.url,
    intro:
      "Przez ponad rok regularnie siadałem na sesje feed forward u Sylwii. Myślałem, że idę po informację zwrotną, a dostałem coś lepszego: kierunek, co zrobić dalej, zamiast rozgrzebywania tego, co już było.",
    rest: [
      "Jeżeli prowadzisz firmę i nikt Ci nie mówi prawdy wprost, tu ją usłyszysz, tylko w formie, z której da się zrobić użytek.",
    ],
  },
  {
    name: "Kamila Szalach",
    role: "właścicielka Wyspa Dzieci, Femmeritum",
    photo: kamilaPhoto.url,
    intro:
      "Sylwia stworzyła naszą grupę mastermindową, ale mam poczucie, że stworzyła coś znacznie większego niż po prostu przestrzeń do rozmów o biznesie.",
    rest: [
      "Jej sposób prowadzenia sprawia, że ludzie bardzo szybko zaczynają rozmawiać ze sobą inaczej, głębiej, szczerzej, bez masek i bez potrzeby udowadniania czegokolwiek. Od początku miała swoją wizję tej grupy, ale jednocześnie dała nam przestrzeń, żebyśmy wspólnie stworzyli jej zasady, kodeks i wzięli odpowiedzialność za to, jak chcemy ze sobą być.",
      "Po kilku miesiącach widzę bardzo wyraźnie, że ta grupa realnie wpływa na życie każdego z nas. I chyba właśnie to jest dla mnie w niej najważniejsze, nie chodzi tylko o to, że stajemy się lepszymi przedsiębiorcami. Mam poczucie, że stajemy się po prostu lepszymi ludźmi.",
      "Dajemy sobie bardzo dużo. Czasem wiedzę, czasem perspektywę, czasem wsparcie, a czasem po prostu prawdę, której sami nie chcielibyśmy sobie powiedzieć. I równie dużo od siebie bierzemy.",
      "Najchętniej napisałabym tu o konkretnych sytuacjach, bo to one najlepiej pokazałyby wartość tej grupy. Ale jednym z naszych najważniejszych kontraktów jest to, że wszystko, co dzieje się między nami, zostaje między nami.",
      "Dlatego zamiast opowiadać, co dokładnie wydarzyło się u nas, mogę powiedzieć tylko jedno: jeśli masz możliwość wejść do grupy prowadzonej przez Sylwię, po prostu sprawdź to na własnej skórze.",
    ],
  },
  {
    name: "Janusz Zieliński",
    role: "Ari10",
    photo: januszPhoto.url,
    // Treść dokładnie tak, jak przesłał autor — bez skrótów i przeróbek.
    intro:
      "Miałem okazję doświadczyć, jak Sylwia prowadzi grupę mastermindową. Łączy psychologiczną precyzję z dobrym rozumieniem biznesu, dlatego rozmowa szybko przechodzi od deklaracji do tego, co naprawdę ważne. Dba o bezpieczeństwo i rytm grupy, więc szczerość przychodzi naturalnie, a każdy wychodzi z konkretną wartością. Sam moderuję mastermind i wiem, jak trudno to osiągnąć, a Sylwia robi to z lekkością.",
    rest: [],
  },
];

function TestimonialCard({ item }: { item: Testimonial }) {
  const [open, setOpen] = useState(false);

  return (
    <figure className="card-soft flex flex-col overflow-hidden rounded-sm border border-steel bg-background p-6 md:p-7">
      <div data-testimonial-header>
        <div className="grid grid-cols-[auto_minmax(0,1fr)] items-start gap-4">
        {item.photo ? (
          <img
            src={item.photo}
            alt={item.name}
            width={64}
            height={64}
            loading="lazy"
            className="h-16 w-16 shrink-0 rounded-full object-cover"
          />
        ) : (
          <div
            aria-hidden="true"
            className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-steel bg-steel-soft text-sm font-medium text-ink-soft"
          >
            {item.name
              .split(" ")
              .map((part) => part[0])
              .join("")}
          </div>
        )}
        <figcaption className="min-w-0 break-words">
          <p className="text-base font-medium text-ink">{item.name}</p>
          {item.role ? (
            <p className="text-sm text-ink-soft" title={item.role}>
              {item.role}
            </p>
          ) : null}
        </figcaption>
        </div>
      </div>

      <blockquote className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
        {/* Zajawka przytnięta do 4 linii, żeby wszystkie karty w rzędzie miały
            równą wysokość treści; po rozwinięciu pokazujemy pełny tekst. */}
        <p className={open ? undefined : "line-clamp-4"}>{item.intro}</p>
        {open && item.rest.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      </blockquote>

      <Button
        type="button"
        variant="link"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        className="mt-auto h-auto min-h-11 items-end self-start px-0 pt-6 text-base font-medium text-ink underline underline-offset-4 transition-colors hover:text-coral-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral"
      >
        {open ? "Zwiń" : "Czytaj więcej"}
      </Button>
    </figure>
  );
}

export function TestimonialsSection() {
  return (
    <section
      id="rekomendacje"
      aria-labelledby="rekomendacje-heading"
      className="content-visibility-auto scroll-mt-24 border-b border-ink/10"
    >
      <div className="container-page py-12 md:py-16">
        <SectionMark number="07" label="Rekomendacje" />
        <h2 id="rekomendacje-heading" className="display-xl mt-6 text-[1.6rem] md:text-[2.2rem]">
          Z perspektywy <span className="serif-display italic text-coral-text">uczestników</span>
        </h2>
        <div className="mt-4">
          <TestimonialsTape
            id="rekomendacje-uczestnikow-lista"
            label="Rekomendacje uczestników"
            items={testimonials}
            itemKey={(item) => item.name}
            renderItem={(item) => <TestimonialCard item={item} />}
            alignHeaders
          />
        </div>
      </div>
    </section>
  );
}
